import React from "react";
import Creation from "./Creation.request";
import Modification from "./Modification.request";
import Sectorisation from "./Sectorisation.request";

import { requests } from "../../../../configs/constants";

const Request = ({ request, token, returnToList, updatePdcCreation }) => {
  const renderSwitch = request => {
    switch (request.type) {
      case requests.PDC_UPDATE:
        return <Modification request={request} token={token} returnToList={returnToList}></Modification>;
      case requests.PDC_CREATION:
        return (
          <Creation
            request={request}
            token={token}
            returnToList={returnToList}
            updatePdcCreation={updatePdcCreation}
          ></Creation>
        );
      case requests.SECTOR_ADD_USER:
        return <Sectorisation request={request} token={token} returnToList={returnToList}></Sectorisation>;
      default:
        return null;
    }
  };
  if (!request) return null;

  return <div style={{ flex: 1, marginBottom: 20, border: "#f0f0f0 1px solid" }}>{renderSwitch(request)}</div>;
};

export default Request;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Request.js/Request.detailpdc.js